import clsx from 'clsx'
import React, { useState } from 'react'
import FlagSummaryItem from './FlagSummaryItem'

export default function RequirementFlagGroup({ requirement, hasAccordion = false }) {
  const [open, setOpen] = useState(true)

  const handleClickChevron = (_e) => {
    if (!hasAccordion) return

    setOpen((o) => !o)
  }

  return (
    <div className="lock-all-requirement-group">
      <button className="flag-summary-accordion__header" onClick={handleClickChevron}>
        <span className="dome-p2 dome-color-dark-grey">{requirement.requirementName}</span>
        {hasAccordion && <i className={clsx('fa fa-angle-down dome-color-dark-grey flag-summary-accordion__chevron', open && 'open')} /> }
      </button>
      {open && (
        <div className="flag-summary-list">
          {requirement.flags.map((flag) => (
            <FlagSummaryItem key={flag.id} flag={flag} />
          ))}
        </div>
      )}
    </div>
  )
}
